import React from 'react';
import PropTypes from 'prop-types';

import offscreenAriaLiveCss from './OffscreenAriaLive.scss';

const OffscreenAriaLive = (props) =>
  <div aria-live="polite"
       aria-relevant={props['aria-relevant']}
       className={offscreenAriaLiveCss.hiddenText}>
    {props.children}
  </div>;

OffscreenAriaLive.defaultProps = {
  'aria-relevant': 'additions text'
};

OffscreenAriaLive.propTypes = {
  'aria-relevant': PropTypes.string.isRequired,
};

export default OffscreenAriaLive;
